import {
    COMMUNICATIONS,
    DECISION_TYPE,
    GOALS,
    PROCESSES,
    GRID_SIZE,
} from './editor.constants';
import { utils } from './legacy-utils';
import axios from 'axios';

function getDecisionIds(decisions) {
    return decisions.map((decision) => utils.removeLongSuffix(decision.decisionId));
}

const copyHandlerByCellType = {
    // no longer supporting Legacy Email, Survey or Twitter cell types in this method
    [PROCESSES.PROCESS_CREATE_APPOINTMENT]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.appointmentId) {
            const { data: appointmentId } = await axios
                .post(`/app/appointmentFunnel/${existingCell.value.appointmentId}/clone`);

            result = { appointmentId };
        }

        return result;
    },
    [DECISION_TYPE]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.decisions) {
            const originalDecisions = existingCell.value.decisions;

            const { data } = await axios.post('/app/decisionFunnel/clone', {
                decisionIds: getDecisionIds(originalDecisions),
            });

            result = {
                decisions: originalDecisions.map((decision) => ({
                    flowId: decision.flowId,
                    decisionId: data[decision.decisionId] || data[`${decision.decisionId}L`],
                })),
            };
        }

        return result;
    },
    [PROCESSES.PROCESS_AUTOMATED_SMS]: async (existingCell, funnelId) => {
        let result = {};

        if (existingCell?.value?.marketingAutomatedSmsId && funnelId) {
            const { data: marketingAutomatedSmsId } = await axios
                .post(`/app/automatedSmsFunnel/${existingCell.value.marketingAutomatedSmsId}/clone`, {
                    funnelId: `${funnelId}`,
                });

            result = { marketingAutomatedSmsId };
        }

        return result;
    },
    [PROCESSES.PROCESS_BARD_EMAIL]: async (existingCell, funnelId) => {
        let result = {};

        if (existingCell?.value?.marketingEmailId && funnelId) {
            const { data: marketingEmailId } = await axios
                .post(`/app/bardEmailFunnel/${existingCell.value.marketingEmailId}/clone`, {
                    funnelId,
                });

            result = { marketingEmailId };
        }

        return result;
    },
    [PROCESSES.PROCESS_CREATE_ORDER]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.createOrderConfigId) {
            const { data: createOrderConfigId } = await axios
                .post(`/app/createOrderFunnel/${existingCell.value.createOrderConfigId}/clone`);

            result = { createOrderConfigId };
        }

        return result;
    },
    [PROCESSES.PROCESS_EMAIL_CONFIRM]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.marketingEmailId) {
            const { data: { marketingEmailId, confirmLinkId } } = await axios
                .post(`/app/emailConfirmFunnel/${existingCell.value.marketingEmailId}/clone`);

            result = {
                marketingEmailId,
                confirmLinkId,
            };
        }

        return result;
    },
    [COMMUNICATIONS.COMMUNICATIONS_FAX]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.marketingFaxId) {
            const { data: marketingFaxId } = await axios
                .post(`/app/faxFunnel/${existingCell.value.marketingFaxId}/clone`);

            result = { marketingFaxId };
        }

        return result;
    },
    [PROCESSES.PROCESS_SET_FIELD_VALUE]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.fieldValueFileBoxId) {
            const { data: fieldValueFileBoxId } = await axios
                .post(`/app/fieldValueFunnel/${existingCell.value.fieldValueFileBoxId}/clone`);

            result = { fieldValueFileBoxId };
        }

        return result;
    },
    [PROCESSES.PROCESS_FULFILLMENT_LIST]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.marketingFulfillmentId) {
            const { data: marketingFulfillmentId } = await axios
                .post(`/app/fulfillmentFunnel/${existingCell.value.marketingFulfillmentId}/clone`);

            result = { marketingFulfillmentId };
        }

        return result;
    },
    [PROCESSES.PROCESS_SEND_HTTP_POST]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.fileBoxId) {
            const { data: fileBoxId } = await axios
                .post(`/app/httpFunnel/${existingCell.value.fileBoxId}/clone`);

            result = { fileBoxId };
        }

        return result;
    },
    [PROCESSES.PROCESS_SEND_HTTP_REQUEST]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.httpRequestConfigId) {
            const { data: httpRequestConfigId } = await axios
                .post(`/app/httpRequestFunnel/requests/${existingCell.value.httpRequestConfigId}/clone`);

            result = { httpRequestConfigId };
        }

        return result;
    },
    [COMMUNICATIONS.COMMUNICATIONS_LETTER]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.marketingLetterId) {
            const { data: marketingLetterId } = await axios
                .post(`/app/letterFunnel/${existingCell.value.marketingLetterId}/clone`);

            result = { marketingLetterId };
        }

        return result;
    },
    [PROCESSES.PROCESS_APPLY_NOTE]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.marketingNoteId) {
            const { data: marketingNoteId } = await axios
                .post(`/app/noteFunnel/${existingCell.value.marketingNoteId}/clone`);

            result = { marketingNoteId };
        }

        return result;
    },
    [GOALS.GOAL_NOTE_APPLIED]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.marketingNoteId) {
            const { data: marketingNoteId } = await axios
                .post(`/app/noteFunnel/${existingCell.value.marketingNoteId}/clone`);

            result = { marketingNoteId };
        }

        return result;
    },
    [PROCESSES.PROCESS_UNLAYER_EMAIL]: async (existingCell, funnelId) => {
        let result = {};

        if (existingCell?.value?.marketingEmailId && funnelId) {
            const { data: marketingEmailId } = await axios.post(
                `/app/unlayerEmailFunnel/template/${existingCell.value.marketingEmailId}/funnel/${funnelId}/clone`,
                { 'Content-Type': 'application/json;charset=UTF-8' },
            );

            result = { marketingEmailId };
        }

        return result;
    },
    [GOALS.GOAL_INTERNAL_FORM]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.internalFormId) {
            const { data: internalFormId } = await axios
                .post(`/app/internalFormFunnel/${existingCell.value.internalFormId}/clone`);

            result = { internalFormId };
        }

        return result;
    },
    [GOALS.GOAL_LANDING_PAGE_SUBMITTED]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.landingPageId) {
            const { data: landingPageId } = await axios
                .post(`/app/landingPageFunnel/${existingCell.value.landingPageId}/clone`);

            result = { landingPageId };
        }

        return result;
    },
    [GOALS.GOAL_WEB_FORM]: async (existingCell) => {
        let result = {};

        if (existingCell?.value?.webformId) {
            const originalWebFormId = existingCell.value.webformId;

            const { data: webformId } = await axios
                .post(`/app/webFormFunnel/${originalWebFormId}/cloneForFunnel`);

            result = { webformId };
        }

        return result;
    },
};

export const deepCopyHandler = async (existingCell, funnelId) => {
    const handlerCallback = copyHandlerByCellType[existingCell.type];

    if (handlerCallback) return handlerCallback(existingCell, funnelId);

    return {};
};

export const copyCell = async (eventCell, newPosition, funnelId) => {
    const copyHandlerResponse = await deepCopyHandler(eventCell, funnelId);

    return {
        value: { ...eventCell?.value, ...copyHandlerResponse },
        cellName: eventCell?.type,
        cellDefaultName: eventCell?.value?.name,
        x: newPosition?.x ? newPosition?.x : (eventCell.mxGeometry?.x ?? 0) + GRID_SIZE,
        y: newPosition?.y ? newPosition?.y : (eventCell.mxGeometry?.y ?? 0) + GRID_SIZE,
    };
};
